export interface FieldSchema {
  type:
    | "text"
    | "select"
    | "email"
    | "phone"
    | "password"
    | "number"
    | "boolean"
    | "checkbox"
    | "radio"
    | "compare"
    | "autocomplete"
    | "search-dropdown"
    | "percentage"
    | "toggle"
    | "readonly"
    | "nationalIdNumber"
    | "money"
    | "zipcode"
    | "date"
    | "year"
    | "dob"
    | "phone"
    | "textarea";
  subtype?: "username" | "address" | "year" | "stipulationText";
  name?: string;
  required?: boolean;
  label?: string;
  hideLabel?: boolean;
  hintPosition?: "top" | "bottom";
  placeholder?: string;
  compareType?:
    | "text"
    | "select"
    | "email"
    | "phone"
    | "number"
    | "boolean"
    | "checkbox"
    | "radio"
    | "password"
    | "zipcode"
    | "date"
    | "textarea";
  compareField?: string;
  validate?: (
    schema: FormField | FieldSchema,
    value: any,
    compare: any
  ) => void;
  validateOnKeyUp?: boolean;
  onBlur?: (schema: FormField | FieldSchema, value: any, compare: any) => void;
  errorMessage?: string;
  autocompleteProperty?: string;
  autoCompleteResultsErrorMessage?: string;
  allowDecimals?: boolean;
  touched?: boolean;
  valid?: boolean;
  errors?: string[];
  allowZero?: boolean;
  autocomplete?: string;
  maxLength?: number;
  disabled?: boolean;
  readOnly?: boolean;
  useYupErrors?: boolean;
  // temporary
  [propName: string]: any;
}

export interface FormField extends FieldSchema {
  valid: boolean;
  touched: boolean;
  errors?: string[];
  tooltipLocation?: string;
}

export interface FormSchema {
  [key: string]: FieldSchema;
}

export interface Form {
  [key: string]: FormField;
}

export interface Option {
  label: string;
  value: any;
  name?: string;
  id?: number;
}

export interface FormChange {
  before: string;
  after: string;
  comment: string;
  key: string;
  name: string;
  label?: string;
  value?: any;
}
export interface FormPatch {
  op: "add" | "replace" | "remove";
  path: string;
  value?: any;
}

export enum FormPatchOperations {
  add = "add",
  replace = "replace",
  remove = "remove",
}

export interface FormChangesResponse {
  comment?: string;
  changes: FormChange[];
  commentPrefix?: string;
  errorMessage: string;
  userDisplayName?: string;
}
